import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";
import { IDS } from "../../IDS";

export const getNotification = async (name, page, per_page) => {
  try {
    return await getData(
      `/website/notification?name=${name || ""}&page=${page ||
        IDS.PAGE}&per_page=${per_page || IDS.PERPAGE}`
    );
  } catch (error) {
    console.log(error);
  }
};
